var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-close_svg__icon",
    viewBox: "0 0 1024 1024",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m575.328 510.496 371.456-369.824c17.568-17.504 17.664-45.824.192-63.424-17.504-17.632-45.792-17.664-63.36-.192L512.032 446.944 143.712 77.216c-17.408-17.504-45.792-17.568-63.328-.096-17.536 17.504-17.568 45.888-.096 63.456l368.224 369.632-371.296 369.6c-17.568 17.504-17.664 45.824-.192 63.424 8.736 8.8 20.256 13.216 31.776 13.216 11.424 0 22.848-4.352 31.584-13.056l371.36-369.696 371.68 373.088C892.192 955.616 903.68 960 915.168 960a44.735 44.735 0 0 0 31.648-13.088c17.504-17.504 17.568-45.824.096-63.392L575.328 510.496zm0 0"
  })));
};

export default SvgIconClose;